/**
 * Section reward component
 * 
 */

import React, { PureComponent } from 'react';

// Components

import Image from '../image/image';

export default class SectionReward extends PureComponent {

	render() {
		
		const { data, items } = this.props;

		return (
		
			<div className="section">
				<div className="container">

					<div className="image"><Image data={data.image}/></div>

					<blockquote className="blockquote blockquote-inline">
						<p>{data.blockquote}</p>
					</blockquote>

					<div className="display display-awards">
						{
							items.map((item, i) => {

								return (
									
									<figure key={'figure-' + i} className="image"><Image data={item.reward_logo}/></figure>
								)
							})
						}
					</div>

				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/sections/section-reward.js